<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item v-if="this.user.user.roles[0].id == 1" :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('zctj')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="listbox">
                <div class="listright" v-loading="loading">
                    <div class="search">
                        <div class="searchleft">
                            <el-form :inline="true" :model="searchform" class="demo-form-inline" @submit.native.prevent >
                                <el-form-item :label="$t('groupName')">
                                    <el-select size="small" v-model="searchform.groupId" style="width:180px;" :placeholder="$t('qxzrole')"  >
                                        <el-option :label="$t('buxian')" :value="0"></el-option>
                                        <el-option v-for="(item,index) in grouplist" :label="item.groupName" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item>
                                    <el-button size="small" type="primary" @click="onSubmit">{{$t('query')}}</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <el-table :data="list" 
                        :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                        <el-table-column prop="groupName" :label="$t('groupName')"></el-table-column>
                        <el-table-column prop="callNum" :label="$t('zczds')"></el-table-column>
                        <el-table-column prop="recall" :label="$t('jrchds')"></el-table-column>
                        <el-table-column prop="recallRate" :label="$t('jrchl')"></el-table-column>
                        <el-table-column :formatter="formatInteres" prop="callMoney" :label="$t('zcje')"></el-table-column>
                        <el-table-column :formatter="formatInteres" prop="recallMoney" :label="$t('chje')"></el-table-column>
                        <el-table-column prop="recallMoneyRate" :label="$t('chjel')"></el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import apiurl from "@/api/public"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {
        LOAD_CHILDREN_OPTIONS
    } from '@riophae/vue-treeselect'
    export default {
        components: {
            Treeselect
        },
        data() {
            var rolesValid = (rule, value, callback) => {
                callback()
            }
            return {
                form: {
                    groupName: null,
                    callNum: null,
                    recall: null,
                    recallRate: null,
                    callMoney: null,
                    recallMoney: null,
                    recallMoneyRate:null
                },
                searchform: {
                    blurry: "",
                },
                loading: false,
                list: [],
                value1:[],
                grouplist:[],
                user:null,
                status: null,
            }
        },
        created() {
            this.user=JSON.parse(localStorage.getItem("userinfo"))
            this.getList()
            this.getgrouplist()
        },
        methods: {
            formatInteres(row, column, value) {
                // 将值转换为数字，若转换失败则返回原值
                const number = Number(value);
                return isNaN(number) ? value : number.toLocaleString('en-US');
            },
            getList() {
                this.loading = true
                _api.get(apiurl.callDayTotal, {
                    groupId: this.searchform.groupId,
                    nation:localStorage.getItem("nation"),
                }).then(res => {
                    this.loading = false
                    this.list = res.data
                })
            },
            getgrouplist(){
                _api.get(apiurl.groupAll, {
                    nation:localStorage.getItem("nation"),
                }).then(res => {
                    this.grouplist = res.data
                })
            },
            onSubmit() {
                this.pageNo = 1
                this.getList()
            },
        }
    }
</script>
<style scoped>
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .listleft {
        width: 20%;
        border: 1px solid #EBEEF5;
    }

    .listright {
        width: 100%;
        margin-left: 1%;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }

    .listrighttop span {
        float: right;
    }

    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }
</style>